import * as React from 'react';
import * as _ from 'lodash';
import {useMemo} from 'react';
import {amazonAccountsApi, Channels} from 'cl-api';
import {getListingsPageHref} from '../../../crazyEditor/containers/Main/utils';
import {updateAmazonAccountName} from '../../ViewDesigns/redux/modules/accountPage';
import {AmazonAccounts as AmazonAccountsData} from '../AccountPageSectionsData';
import ChannelAccounts from './ChannelAccounts';
import {useSelector, useDispatch} from 'react-redux';
import {useEffect} from 'react';
import {
  getAmazonAccounts,
  getLastAmazonAccountsError,
} from '../../../Layout/MyAccountLayout/ApplicationLayoutSelectors';
import {addDynamicDialog} from '../../../crazyEditor/redux/modules/panel/panel';
import AmazonAccountErrorDialog, {
  AmazonAccountErrorDialogProps,
} from '../../../shared/components/Dialogs/AddAmazonAccountDialog/AmazonAccountErrorDialog';

const AmazonAccounts: React.FunctionComponent = () => {
  const rawAccounts = useSelector(getAmazonAccounts);
  const accounts = useMemo(
    () =>
      _.map(rawAccounts, ({amazonSellerId, name, quantitySyncEnabled}, index) => ({
        name,
        id: amazonSellerId,
        quantitySyncEnabled,
        listingsPageHref: getListingsPageHref(rawAccounts[index]),
      })),
    [rawAccounts]
  );

  const onUpdateAccountName = amazonSellerId => async event => {
    const name = event.target.value;
    await amazonAccountsApi.updateAmazonAccount(amazonSellerId, {name}, {credentials: 'include'});
    updateAmazonAccountName(amazonSellerId, name);
  };

  const lastAmazonError = useSelector(state => getLastAmazonAccountsError(state));
  const dispatch = useDispatch();
  useEffect(() => {
    if (lastAmazonError) {
      dispatch(addDynamicDialog<AmazonAccountErrorDialogProps>(AmazonAccountErrorDialog, {message: lastAmazonError}));
    }
  }, [lastAmazonError]);

  return <ChannelAccounts channel={Channels.Amazon} accounts={accounts} onUpdateAccountName={onUpdateAccountName} />;
};

export default _.assign(AmazonAccounts, AmazonAccountsData);
